import React, { useState, useEffect } from 'react'
import axios from 'axios'
import './MySubscriptionPage.css'
import Header from '../components/Header'
import { useNavigate } from 'react-router-dom'

const getAuth = () =>
  document.cookie.replace(/(?:(?:^|.*;\s*)auth\s*=\s*([^;]*).*$)|^.*$/, "$1")

const PLANS = [
  { key: 'daily',      formKey: 'dailyPrice',      label: 'Daily',       icon: '☀️', period: 'per day' },
  { key: 'monthly',    formKey: 'monthlyPrice',     label: 'Monthly',     icon: '📅', period: 'per month' },
  { key: 'quarterly',  formKey: 'quarterlyPrice',   label: 'Quarterly',   icon: '🗓️', period: 'per 3 months' },
  { key: 'halfYearly', formKey: 'halfYearlyPrice',  label: 'Half Yearly', icon: '📆', period: 'per 6 months' },
  { key: 'yearly',     formKey: 'yearlyPrice',      label: 'Yearly',      icon: '🏆', period: 'per year' },
]

const MySubscriptionPage = () => {
  const [subscription, setSubscription] = useState(null)
  const [editing, setEditing] = useState(false)
  const [formValues, setFormValues] = useState({
    dailyPrice: '',
    monthlyPrice: '',
    quarterlyPrice: '',
    halfYearlyPrice: '',
    yearlyPrice: '',
  })
  const navigate = useNavigate()

  useEffect(() => { fetchSubscription() }, [])

  const fetchSubscription = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/subscriptions`, {
        headers: { auth: getAuth() }
      })
      const data = response.data[0]
      setSubscription(data)
      setFormValues({
        dailyPrice: data?.daily ?? '',
        monthlyPrice: data?.monthly ?? '',
        quarterlyPrice: data?.quarterly ?? '',
        halfYearlyPrice: data?.halfYearly ?? '',
        yearlyPrice: data?.yearly ?? '',
      })
    } catch (error) {
      console.error('Error fetching subscription:', error)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormValues(prev => ({ ...prev, [name]: value }))
  }

  const handleCancel = () => {
    setEditing(false)
    setFormValues({
      dailyPrice: subscription?.daily ?? '',
      monthlyPrice: subscription?.monthly ?? '',
      quarterlyPrice: subscription?.quarterly ?? '',
      halfYearlyPrice: subscription?.halfYearly ?? '',
      yearlyPrice: subscription?.yearly ?? '',
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/subscriptions`, formValues, {
        headers: { auth: getAuth() }
      })
      setEditing(false)
      fetchSubscription()
    } catch (error) {
      console.error('Error updating subscription:', error)
    }
  }

  return (
    <div className="sub-page">
      <Header />
      <div className="sub-content">
        {/* Page Header */}
        <div className="sub-page-header">
          <div>
            <h1 className="sub-page-title">Subscription Plans</h1>
            <p className="sub-page-sub">Set membership prices for your gym</p>
          </div>
          <div className="sub-nav-btns">
            <button className="sub-btn-ghost" onClick={() => navigate('/gallery')}>← Gallery</button>
            <button className="sub-btn-ghost" onClick={() => navigate('/banking')}>Banking →</button>
          </div>
        </div>

        {editing ? (
          <div className="sub-edit-card">
            <div className="sub-edit-head">
              <h2>Edit Subscription Prices</h2>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="sub-edit-body">
                <div className="sub-form-grid">
                  {PLANS.map(plan => (
                    <div className="sub-form-group" key={plan.formKey}>
                      <label>{plan.icon} {plan.label} Price (INR)</label>
                      <input
                        type="number"
                        name={plan.formKey}
                        value={formValues[plan.formKey]}
                        onChange={handleInputChange}
                        placeholder="0"
                        min="0"
                        required
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="sub-edit-foot">
                <button type="button" className="sub-btn-ghost" onClick={handleCancel}>Cancel</button>
                <button type="submit" className="sub-btn-primary">Save Prices</button>
              </div>
            </form>
          </div>
        ) : (
          <>
            <div className="sub-plans-grid">
              {PLANS.map(plan => (
                <div className="sub-plan-card" key={plan.key}>
                  <div className="sub-plan-icon">{plan.icon}</div>
                  <div className="sub-plan-label">{plan.label}</div>
                  <div className="sub-plan-price">
                    <span className="sub-plan-currency">₹</span>
                    {subscription?.[plan.key] ?? '—'}
                  </div>
                  <div className="sub-plan-period">{plan.period}</div>
                </div>
              ))}
            </div>
            <button className="sub-edit-btn" onClick={() => setEditing(true)}>
              ✏️ Edit Prices
            </button>
          </>
        )}
      </div>
    </div>
  )
}

export default MySubscriptionPage
